import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import {
	CREATE_COMPONENT,
	UPDATE_COMPONENT
} from 'graphqlQueriesAndMutations/mutations';
import { graphql } from 'services/api';
import { DynamicPageProps } from 'types/DynamicPageProps';

function findItemIndexById(
	id: string,
	items: ItemDynamicPageInPhone[]
): number {
	const index = items.findIndex((item) => item.id === id);
	return index !== -1 ? index : 0;
}

interface RespSaveModuleOnBackProps {
	isSuccess: boolean;
	data: null | {
		createComponent: {
			data: any;
			id: string;
			slug: string;
			__typename: string;
		};
	};
}

export async function saveModuleOnBack(
	moduleToSave: ItemDynamicPageInPhone,
	dynamicPageSelected: DynamicPageProps,
	itensOnPhone: ItemDynamicPageInPhone[],
	handleNotify: any
) {
	const resp: RespSaveModuleOnBackProps = { data: null, isSuccess: false };
	await graphql
		.mutate({
			mutation: CREATE_COMPONENT,
			variables: {
				createComponentInput: {
					data: moduleToSave.data,
					languageSlug: 'en',
					page_slug: dynamicPageSelected.slug,
					position: findItemIndexById(moduleToSave.id, itensOnPhone),
					slug: moduleToSave.slug
				}
			}
		})
		.then((res) => {
			if (res.data) {
				resp.data = res?.data?.createComponent?.data || null;
				resp.isSuccess = true;
			}
		})
		.catch((error) => {
			resp.data = null;
			resp.isSuccess = false;
			handleNotify(
				error?.message || 'Algum erro aconteceu ao incluir o módulo no app',
				'error'
			);
		});

	return resp;
}

interface EditModuleOnBackRespProps {
	isSuccess: boolean;
}

export async function editModuleOnBack(
	moduleToSave: ItemDynamicPageInPhone,
	handleNotify: any
) {
	const resp: EditModuleOnBackRespProps = { isSuccess: false };
	await graphql
		.mutate({
			mutation: UPDATE_COMPONENT,
			variables: {
				updateComponentInput: {
					data: moduleToSave.data,
					id: moduleToSave.id
				}
			}
		})
		.then((res) => {
			if (res.data) {
				resp.isSuccess = true;
			}
		})
		.catch((error) => {
			resp.isSuccess = false;
			handleNotify(
				error?.message || 'Algum erro aconteceu ao editar o módulo no app',
				'error'
			);
		});

	return resp;
}
